import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { DxDateBoxComponent } from 'devextreme-angular';
import { ConvertHelper } from 'libs/abc/core';
import { StylingMode } from '../../../base/src/abcComponent.model';
import {
  DatePickerApplyValueMode,
  DatepickerStyle,
  DatePickerType,
  DateValidationMessageMode,
  DateValidationStatus,
  IDatepicker,
  PickerType,
} from '../../../base/src/abcDatepicker/abcDatepicker';

@Component({
    selector: '',
    template: `<div class="devExDatePickerStyle">
      <dx-date-box
        #dxDatePicker
        [stylingMode]="stylingMode"
        [id]="id"
        [(value)]="value"
        [label]="placeholder"
        [name]="name"
        [type]="type"
        [width]="width"
        [activeStateEnabled]="activeStateEnabled"
        [adaptivityEnabled]="adaptivityEnabled"
        [acceptCustomValue]="acceptCustomValue"
        [applyValueMode]="applyValueMode"
        [applyButtonText]="applyButtonText"
        [cancelButtonText]="cancelButtonText"
        [validationMessageMode]="validationMessageMode"
        [validationStatus]="validationStatus"
        [opened]="opened"
        [openOnFieldClick]="openOnFieldClick"
        [pickerType]="pickerType"
        [readOnly]="readOnly"
        [rtlEnabled]="rtlEnabled"
        [disabled]="disabled"
        [showClearButton]="showClearButton"
        [showDropDownButton]="showDropDownButton"
        [class]="class"
        [min]="min"
        [max]="max"
        [displayFormat]="this.type == dateType ? dateFormat : null"
        [valueChangeEvent]="valueChangeEvent"
        (mouseenter)="isEllipsisActive(id)"
        (mouseleave)="toggleDefault()"
        (onValueChanged)="dataChanged($event)"
        labelMode="floating"
        [useMaskBehavior]="useMaskBehavior"
      >
      </dx-date-box>
    </div>
    <dx-popover
      #componentRef
      [id]="id"
      [target]="'#' + id"
      [(visible)]="displayTooltip"
      [contentTemplate]="placeholder"
    >
    </dx-popover>`,
    styleUrls: ['./devExDatePicker.component.scss'],
    standalone: false
})
export class DevExDatePickerComponent implements IDatepicker, OnInit, AfterViewInit {
  @ViewChild('dxDatePicker', { static: true }) dxDatePicker: DxDateBoxComponent;
  @Input() id: string;
  @Input() placeholder?: string;
  private _value: string;
  @Input()
  get value(): any {
    return this._value;
  }
  set value(val: any) {
    this._value = val;
    this.valueChange.emit(val);
  }
  @Input() symbol: string;
  @Input() class: string;
  @Input() width: string | number;
  @Input() min: Date;
  @Input() max: Date;
  @Input() stylingMode: StylingMode = StylingMode.Underlined;
  @Input() readOnly: boolean = false;
  @Input() name: string;
  @Input() applyValueMode: DatePickerApplyValueMode;
  @Input() applyButtonText: string;
  @Input() acceptCustomValue: boolean = false;
  @Input() cancelButtonText: string;
  @Input() validationMessageMode: DateValidationMessageMode;
  @Input() activeStateEnabled: boolean;
  @Input() adaptivityEnabled: boolean;
  @Input() opened: boolean;
  @Input() openOnFieldClick: boolean;
  @Input() showClearButton: boolean;
  @Input() showDropDownButton: boolean;
  @Input() pickerType: PickerType = PickerType.Calendar;
  @Input() rtlEnabled: boolean;
  @Input() disabled: boolean;
  @Input() validationStatus: DateValidationStatus;
  @Input() valueChangeEvent: 'keyup' | 'blur' | 'change' | 'input' | 'focusout';
  @Input() isConverted: boolean = false;
  @Input() useMaskBehavior: boolean;
  private _type: DatePickerType = DatePickerType.Date;
  @Input()
  get type() {
    return this._type;
  }

  set type(type) {
    this._type = type;
  }
  @Input() visible: boolean;
  @Output() onChange: EventEmitter<any> = new EventEmitter();
  @Output() valueChange: EventEmitter<any> = new EventEmitter();

  displayTooltip: boolean = false;
  parentElement: HTMLElement;
  currentElement: HTMLElement;
  dateFormat: Object = { year: 'numeric', month: '2-digit', day: '2-digit' };
  dateType: DatePickerType = DatePickerType.Date;

  constructor(private renderer2: Renderer2, private cdr: ChangeDetectorRef) {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.dxDatePicker.instance.registerKeyHandler('del', () => {
      this.value = null;
      this.onChange.emit(null);
    });
    if (this.class) {
      const element = this.dxDatePicker['element'].nativeElement;
      this.renderer2.addClass(element, this.class);
    }
  }
  dataChanged(event) {
    let value = event.value;
    let dateType = typeof value;
    let result;
    if (!value) value = null;
    //FIXME dateType test should be removed
    if (!this.isConverted) {
      if (value && this.type == DatePickerType.Time && dateType == 'object') {
        result = value.toISOString().slice(0, 10) + 'T' + ConvertHelper.toISOTimeString(value);
      } else if (value && this.type == DatePickerType.Date && dateType == 'object') {
        result =
          value.getFullYear() +
          '-' +
          ('0' + (value.getMonth() + 1)).slice(-2) +
          '-' +
          ('0' + value.getDate()).slice(-2);
      } else if (this.type == DatePickerType.Time && dateType == 'string' && !event.value.includes('T')) {
        //devextreme date box does not accept time as value (example 00:00:00) making a problem in the onValueChanged event
        result = '1753-01-01T00:00:00';
      } else {
        result = value;
      }
      this.onChange.emit(result);
    } else {
      this.onChange.emit(value);
    }
    this.cdr.detectChanges();
  }

  setDatepickerStyle(style: DatepickerStyle) {
    if (style) {
      if (style.width) {
        this.width = style.width;
      }
    }
  }

  setCustomDataAttributes(data: Object) {}
  toggleDefault() {
    this.displayTooltip = false;
  }
  isEllipsisActive(id) {
    this.currentElement = document.getElementById(id).querySelector('.dx-placeholder');
    this.parentElement = document.getElementById(id).querySelector('.dx-texteditor-input-container');
    this.displayTooltip = this.currentElement.scrollWidth >= this.parentElement.scrollWidth;
  }

  // displayFormat() {
  //   if (this.type !== DatePickerType.Time) {
  //     return { year: 'numeric', month: '2-digit', day: '2-digit' };
  //   }
  // }
  getValidationStatus() {
    return this.dxDatePicker.instance.option('isValid');
  }
}
